__turbopack_context__.v({
  "btnDarkPrimary": "LoginArea-module-scss-module__PduKVG__btnDarkPrimary",
  "btnDarkSecondary": "LoginArea-module-scss-module__PduKVG__btnDarkSecondary",
  "cell": "LoginArea-module-scss-module__PduKVG__cell",
  "desktop": "LoginArea-module-scss-module__PduKVG__desktop",
  "last": "LoginArea-module-scss-module__PduKVG__last",
  "loggedinPopoverMenu": "LoginArea-module-scss-module__PduKVG__loggedinPopoverMenu",
  "menuLink": "LoginArea-module-scss-module__PduKVG__menuLink",
  "notLoggedIn": "LoginArea-module-scss-module__PduKVG__notLoggedIn",
  "right": "LoginArea-module-scss-module__PduKVG__right",
});
